import { forwardRef } from 'react'
import { useModalContext } from '../modal'
import cls from 'classnames'
import { IconButton, CloseIcon } from '@paypalcorp/pp-react'
import * as React from 'react'
import styles from './modal-close-button.module.css'
import { callAllHandlers } from '../../utils/misc'
import type * as Polymorphic from '../../../../react-utils/polymorphic'

/**
 * ModalCloseButton is used closes the modal.
 *
 * You don't need to pass the `onClick` to it, it reads the
 * `onClose` action from the modal context.
 */

export interface ModalCloseButtonProps
  extends React.HTMLAttributes<HTMLButtonElement> {}

export const ModalCloseButton = forwardRef((props, ref) => {
  const { onClick, className, ...rest } = props
  const { onClose } = useModalContext()

  const _className = cls(styles.paypal_modal__close_button, className)

  return (
    <IconButton
      ref={ref as any}
      className={_className}
      onClick={callAllHandlers(onClick, (event: any) => {
        event.stopPropagation()
        onClose()
      })}
      {...rest}
      tertiary
      svgIconComponent={CloseIcon}
    />
  )
}) as Polymorphic.ForwardRefComponent<any, ModalCloseButtonProps>

ModalCloseButton.displayName = 'ModalCloseButton'
